type StepperProps = {
  step: number;
  steps: number;
};

const Stepper = ({ step, steps }: StepperProps) => {
  const stepWidth = 100 / steps;

  return (
    <>
      <div className='w-full'>
        <div className='flex justify-center'>
          <div className='text-forest-500 text-sm pb-2'>
            {step} of {steps}
          </div>
        </div>
        <div className='h-[2px] bg-forest-100 w-full relative'>
          <div
            className='absolute top-0 left-0 h-[2px] bg-forest-500'
            style={{ width: `${stepWidth * step}%` }}
          />
        </div>
      </div>
    </>
  );
};

export default Stepper;
